import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BaseUrl } from "../../helper/BaseUrl";

export default function ContactForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const sourceUrl = typeof window !== "undefined" ? sessionStorage.getItem("source_url") || "" : "";

  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [formData, setFormData] = useState({
    form_type: "contact_form",
    name: "",
    email: "",
    phone: "",
    message: "",
    source_url: sourceUrl,
    current_url: currentUrl,
  })

  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;
    if (name === "phone") {
      updatedValue = value.replace(/\D/g, "");
    }
    if (name === "name") {
      updatedValue = value.replace(/[^a-zA-Z\s]/g, "");
    }
    setFormData((prev) => ({
      ...prev,
      [name]: updatedValue,
      source_url: sourceUrl,
      current_url: currentUrl,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
      form: "",
    }));
  };


  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.phone) {
      newErrors.phone = "Mobile number is required";
    } else if (formData.phone.length !== 10) {
      newErrors.phone = "Mobile number must be 10 digits";
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Enter valid email";
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    setErrors((prev) => ({
      ...prev,
      ...newErrors,
    }));

    return Object.keys(newErrors).length === 0;
  };




  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      setLoading(true);
      const response = await fetch(`${BaseUrl}/api/contact/store`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const result = await response.json();
      if (result.error === false) {
        toast.success(result.message || "Form submitted successfully");

        setTimeout(() => {
          navigate("/thankyou");
        }, 1000);
      } else {
        setErrors((prev) => ({
          ...prev,
          form: result.message || "Submission failed",
        }));
      }
    } catch (error) {
      console.error("Error:", error);

      setErrors((prev) => ({
        ...prev,
        form: "Something went wrong while submitting the form.",
      }));
    } finally {
      setLoading(false);
    }
  };



  return (
    <>
      <section className="contactpage-form">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-lg-6 col-md-8">
              <div className='contactform-head'>
                <h2 className='heading'>Connect With Our Hospitality Team</h2>
                <p>Do you have questions about the all-inclusive experiences in our hotels or resorts? Need some additional information? Don’t hesitate! Feel free to call us today!</p>
              </div>

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-field">
                  <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Name*" className="form-control" required />
                  {errors.name && <p className="error-message">{errors.name}</p>}
                </div>

                <div className="form-field">
                  <input name="phone" type="tel" value={formData.phone} onChange={handleChange} minLength={10} maxLength={10} required placeholder="Mobile*" className="form-control" />
                  {errors.phone && <p className="error-message">{errors.phone}</p>}
                </div>

                <div className="form-field">
                  <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email Address*" className="form-control" required />
                  {errors.email && <p className="error-message">{errors.email}</p>}
                </div>

                <div className="form-field">
                  <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Your Message*" className="form-control" required />
                  {errors.message && <p className="error-message">{errors.message}</p>}
                </div>

                <button style={{ opacity: loading ? "0.3" : "1" }} disabled={loading} type="submit" className="default-btn color-btn"> 
                  {loading ? "Submitting..." : "Send Message"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
